"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _AffiliateModal = _interopRequireDefault(require("./AffiliateModal"));
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _affiliateActions = require("../../redux/actions/affiliateActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var affiliate = state.affiliate;
  return {
    initialValues: {
      tag: affiliate.affiliateTag
    }
  };
};
var mapDispatchToProps = {
  getAffiliate: _affiliateActions.getAffiliate
};
var Form = (0, _reduxForm.reduxForm)({
  form: 'updateAffiliate',
  onSubmit: function onSubmit(payload, dispatch) {
    return dispatch((0, _affiliateActions.updateAffiliate)(payload));
  }
})(_AffiliateModal["default"]);
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Form);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.NEW_AFFILIATE_KEY
})(container);